import { CognitoUserPool } from "amazon-cognito-identity-js"

const poolData = {
  UserPoolId: "us-east-2_PpQrb1lLw",
  ClientId: "4phd4sp7pis8ut0damagbu0894", // App integrations // App clients list
}

export default new CognitoUserPool(poolData)
